(() => {
  // Swatch King hides the native picker and replaces its own option markup.
  // Keep Kiwi's real trigger in a stable slot and forward clicks from a small
  // theme-owned button beside the *visible* Size caption.
  const modalSelector = '.ks-chart-container.sizing-chart-container.ks-container-with-modal';
  const triggerSelector = '.ks-chart-modal-link, .ks-chart-modal-button';
  const buttons = new WeakMap();
  let scheduled = false;

  function isVisible(element) {
    if (element.closest('.visually-hidden-label, .visually-hidden, .sr-only, [hidden], [aria-hidden="true"]')) return false;
    const style = getComputedStyle(element);
    return element.getClientRects().length > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  }

  function findSizeCaption(productInfo) {
    // App markup varies between versions. Match the caption's text rather than
    // an input named Size, which can belong to Swatch King's hidden source.
    const scopes = Array.from(productInfo.querySelectorAll(
      'variant-swatch-king .swatch-label-container .swatch-label .swatch-option-name'
    ));
    scopes.push(...productInfo.querySelectorAll('variant-swatch-king, .swatch-option-name, [option-name="Size"]'));
    scopes.push(...productInfo.querySelectorAll('variant-picker legend'));
    for (const scope of scopes) {
      const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const parent = node.parentElement;
        if (/^\s*Size\s*[:\-–]?\s*$/i.test(node.textContent) &&
            !parent.closest('button, a, script, style, [role="option"], [data-hib-size-chart-anchor]') &&
            isVisible(parent)) return node;
      }
    }
    return null;
  }

  function setFlag(element, name, enabled) {
    if (element && element.hasAttribute(name) !== enabled) element.toggleAttribute(name, enabled);
  }

  function placeCharts() {
    scheduled = false;
    document.querySelectorAll('.product-info').forEach((productInfo) => {
      const charts = Array.from(productInfo.querySelectorAll(modalSelector));
      let button = buttons.get(productInfo);
      if (!charts.length) {
        if (button) button.remove();
        productInfo.querySelectorAll('[data-hib-size-chart-collapsed]').forEach((element) => {
          setFlag(element, 'data-hib-size-chart-collapsed', false);
        });
        return;
      }

      let anchor = productInfo.querySelector('[data-hib-size-chart-anchor], #hib-size-chart-anchor');
      if (!anchor) {
        const buyButtons = productInfo.querySelector('.product-info__buy-buttons');
        if (!buyButtons) return;
        anchor = document.createElement('div');
        anchor.setAttribute('data-hib-size-chart-anchor', '');
        buyButtons.before(anchor);
      }

      charts.forEach((chart) => {
        if (!anchor.contains(chart)) {
          const appBlock = chart.closest('.shopify-block');
          anchor.appendChild(chart);
          // A genuinely empty former app block must not retain a theme row gap.
          if (appBlock && !appBlock.innerHTML.trim()) {
            setFlag(appBlock, 'data-hib-size-chart-collapsed', true);
          }
        }
      });

      const originalTrigger = anchor.querySelector(triggerSelector);
      const caption = findSizeCaption(productInfo);
      const inline = Boolean(originalTrigger && caption);
      if (inline) {
        if (!button) {
          button = document.createElement('button');
          button.type = 'button';
          button.className = 'hib-size-chart-trigger';
          button.setAttribute('aria-haspopup', 'dialog');
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            // Resolve the current trigger: Kiwi can replace it after a change.
            productInfo.querySelector(modalSelector)?.querySelector(triggerSelector)?.click();
          });
          buttons.set(productInfo, button);
        }
        // Respect Kiwi's selected display mode, including its label and icon.
        button.classList.toggle('hib-size-chart-trigger--button', originalTrigger.matches('.ks-chart-modal-button'));
        const content = originalTrigger.innerHTML.trim() || 'Size chart';
        if (button.innerHTML !== content) button.innerHTML = content;
        if (caption.nextSibling !== button) caption.after(button);
      } else if (button) {
        button.remove();
      }

      setFlag(anchor, 'data-hib-size-chart-collapsed', inline);
      const wrapper = anchor.parentElement;
      if (wrapper.matches('.product-info__liquid') && wrapper.children.length === 1) {
        setFlag(wrapper, 'data-hib-size-chart-collapsed', inline);
      }
    });
  }

  function schedulePlacement() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(placeCharts);
  }

  // Recreate the caption button after option/section replacement, and reconsider
  // visibility when Swatch King finishes hiding/showing its pickers.
  new MutationObserver(schedulePlacement).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden']
  });
  schedulePlacement();
})();
